import { common } from '@/locales/de-DE/common';
import { auth } from '@/locales/de-DE/auth';
import { navigation } from '@/locales/de-DE/navigation';
import { profile } from '@/locales/de-DE/profile';
import { workspace } from '@/locales/de-DE/workspace';
import { billing } from '@/locales/de-DE/billing';
import { work } from '@/locales/de-DE/work';
import { assets } from '@/locales/de-DE/assets';
import { inspections } from '@/locales/de-DE/inspections';
import { jobs } from '@/locales/de-DE/jobs';
import { lifecycleGate } from '@/locales/de-DE/lifecycleGate';
import { contacts } from '@/locales/de-DE/contacts';
import { copilot } from '@/locales/de-DE/copilot';
import { home } from '@/locales/de-DE/home';
import { assistant } from '@/locales/de-DE/assistant';
import { activity } from '@/locales/de-DE/activity';
import { schedule } from '@/locales/de-DE/schedule';
import { sites } from '@/locales/de-DE/sites';
import { timeline } from '@/locales/de-DE/timeline';
import { compliance } from '@/locales/de-DE/compliance';
import { guide } from '@/locales/de-DE/guide';
import { packs } from '@/locales/de-DE/packs';
import { notifications } from '@/locales/de-DE/notifications';
import { enUSResources } from '@/locales/en-US';
import { mergeLocaleResources } from '@/locales/mergeLocaleResources';

export const deDEResources = mergeLocaleResources(enUSResources, {
  common,
  auth,
  navigation,
  profile,
  workspace,
  billing,
  work,
  assets,
  inspections,
  jobs,
  lifecycleGate,
  contacts,
  copilot,
  home,
  assistant,
  activity,
  schedule,
  sites,
  timeline,
  compliance,
  guide,
  packs,
  notifications,
} as const);
